import styles from "./styles.module.css";

export default function Toggle({ toggle }) {
  return (
    <div className={styles.toggle}>
      <div onClick={() => toggle.set("props")} className={styles.toggleText}>
        PROPS
      </div>
      <div
        onClick={() => toggle.set("conditions")}
        className={styles.toggleText}
      >
        CONDITIONS
      </div>
      <div
        onClick={() => toggle.set("workflows")}
        className={styles.toggleText}
      >
        EVENTS
      </div>
      <div className={`${styles.button} ${styles[toggle.value]}`} />
    </div>
  );
}
